import Pagination from '@atlaskit/pagination';

export type { PaginationPropTypes } from '@atlaskit/pagination';
export default Pagination;
